import { Box, Button, Grid } from "@material-ui/core";
import {
    DurationType,
    durationTypeDescription,
    RaceConfigDefaultValues,
    RaceConfiguration,
} from "api";
import { Formik } from "formik";
import React from "react";
import {
    FormButton,
    InputFieldFormik,
    SelectFieldFormik,
} from "ui/componentes";
import { yupRequiredField } from "ui/componentes/Form/functions/validationMessages";
import { SelectOption } from "ui/componentes/Form/SelectFieldFormik/CustomSelect";
import TimeFieldFormik from "ui/componentes/Form/TimeFieldFormik/TimeFieldFormik";
import * as Yup from "yup";

interface RaceConfigurationProps {
    onAdd: (raceConfiguration: RaceConfiguration) => void;
}

const FormValidation = Yup.object<RaceConfiguration>().shape<RaceConfiguration>(
    {
        durationType: Yup.string()
            .required(yupRequiredField)
            .oneOf([DurationType.LAPS, DurationType.MINUTES]),
        duration: Yup.number().required(yupRequiredField),
        timeOfDay: Yup.string().required(yupRequiredField),
        invertedPositions: Yup.number().required(yupRequiredField),
    }
);

const addConfiguration = (submitForm, resetForm) => async () => {
    await submitForm();
    resetForm();
};

const onSubmitForm = (onAdd) => (raceConfiguration, { setSubmitting }) => {
    if (onAdd) {
        onAdd(raceConfiguration);
    }
    setSubmitting(false);
};

const durationTypeOptions: SelectOption[] = [
    {
        label: durationTypeDescription(DurationType.LAPS),
        value: DurationType.LAPS,
    },
    {
        label: durationTypeDescription(DurationType.MINUTES),
        value: DurationType.MINUTES,
    },
];

const RaceConfigurationForm: React.FC<RaceConfigurationProps> = ({ onAdd }) => {
    return (
        <Formik
            enableReinitialize={true}
            initialValues={RaceConfigDefaultValues}
            validationSchema={FormValidation}
            onSubmit={onSubmitForm(onAdd)}
        >
            {({ values, isSubmitting, submitForm, resetForm }) => {
                return (
                    <Grid container spacing={1}>
                        <Grid item md={2} xs={12}>
                            <SelectFieldFormik
                                id="durationType"
                                name="durationType"
                                label="Duração em"
                                options={durationTypeOptions}
                            />
                        </Grid>
                        <Grid item md={1} xs={12}>
                            <InputFieldFormik
                                id="duration"
                                name="duration"
                                label={durationTypeDescription(
                                    values.durationType
                                )}
                                type="number"
                            />
                        </Grid>
                        <Grid item md={2} xs={12}>
                            <TimeFieldFormik
                                id="timeOfDay"
                                name="timeOfDay"
                                label="Hora do dia"
                                views={["hours", "minutes"]}
                                openTo="hours"
                                autoOk={false}
                            />
                        </Grid>
                        <Grid item md={2} xs={12}>
                            <InputFieldFormik
                                id="weather"
                                name="weather"
                                label="Clima"
                            />
                        </Grid>
                        <Grid item md={2} xs={12}>
                            <InputFieldFormik
                                id="invertedPositions"
                                name="invertedPositions"
                                label="Posiçoes invertidas"
                                type="number"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Box marginTop={1} display="flex">
                                <FormButton
                                    color="primary"
                                    onClick={addConfiguration(
                                        submitForm,
                                        resetForm
                                    )}
                                    loading={isSubmitting}
                                >
                                    Adicionar Bateria
                                </FormButton>
                                <Button
                                    onClick={() => resetForm()}
                                    style={{ marginLeft: 5 }}
                                >
                                    Cancelar
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                );
            }}
        </Formik>
    );
};

export { RaceConfigurationForm };
